import React from 'react'
import { CenterBox } from '@repo/ui/components/center-box'
import { Typography } from '@repo/ui/components/typography'
import { useTranslate } from '@repo/shared/hooks'
import Image from 'next/image'

export const MessagesEmptyState = () => {
  const { t } = useTranslate()

  return (
    <CenterBox className=' flex-col gap-lg py-10xl'>
      <Image src='/images/home.webp' alt='empty-state' width={64} height={64} />
      <Typography
        variant='p'
        size='sm'
        color='text-base-surface-100'
        className='text-center'
      >
        {t('profileMessagesPage_empty_state_title')}
      </Typography>
    </CenterBox>
  )
}
